import ajax from '../http/ajax'

export const getCarModel = params => {
    return ajax.get('getCarModel', params)
}
